import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer';
import { useState } from 'react';
import Button from '../../../../components/button';
import Dropdown from '../../../../components/dropdown';
import { File } from '../../../../components/icons';
import { Modal } from '../../../../components/modal';
import Textarea from '../../../../components/textarea';
import {
  IBusinessUpdateComponent,
  VerificationEnum,
} from '../../../../interface/business';
import { useBusinessUpdate } from '../../../../services/business';
import { capitalized } from '../../../../utils/capitalize';
import { getExtension } from '../../../../utils/getFileExtension';

const Mermat = ({ item, refetch }: IBusinessUpdateComponent) => {
  const [viewFile, setViewFile] = useState<boolean>(false);

  const [data, setData] = useState({
    reasons: item.verification.mermat.reasons ?? '----',
    validated: item.verification.mermat.validated ?? '----',
  });

  const verificationOptions = Object.entries(VerificationEnum).map(
    ([label, value]) => ({
      label: capitalized(label).replaceAll('_', ' '),
      value,
    })
  );

  const { mutate, isLoading } = useBusinessUpdate();

  const extension = getExtension(item.verification.mermat.file ?? '');

  const handleSubmit = () => {
    mutate(
      {
        id: item._id,
        body: {
          'verification.mermat.reasons': data.reasons,
          'verification.mermat.validated': data.validated,
        },
      },
      {
        onSuccess: refetch,
      }
    );
  };

  return (
    <div>
      <Modal
        isVisible={viewFile}
        close={setViewFile}
        width="large"
        padding
        header
        center
        title="Memorandum"
      >
        <div>
          {extension === 'pdf' ? (
            <DocViewer
              documents={[{ uri: item.verification.mermat.file }]}
              pluginRenderers={DocViewerRenderers}
            />
          ) : (
            <img src={item.verification.mermat.file} alt="utilty bill" />
          )}
        </div>
      </Modal>
      <div className="flex flex-col py-4 px-4">
        <div className="flex justify-between items-center py-2">
          <small>File</small>
          {item.verification?.mermat?.file ? (
            <div onClick={() => setViewFile(true)}>
              <File height={24} width={24} fill="#fff" />
            </div>
          ) : (
            <small className="text-red-500">N/A</small>
          )}
        </div>

        <div className="flex justify-between items-center py-2">
          <small>Verification</small>
          <div className="flex items-center gap-2">
            {data.validated === VerificationEnum.ACCEPTED && (
              <div className="h-6 w-6 rounded-full bg-green-500"></div>
            )}
            <small>
              <Dropdown
                top={true}
                label="Verification"
                dropdownClassName="z-50"
                defaultValue={capitalized(data.validated).replaceAll('_', ' ')}
                option={verificationOptions}
                onChange={(e) => {
                  setData({ ...data, validated: e?.value });
                }}
              />
            </small>
          </div>
        </div>

        <div className="py-2">
          <small className="text-xs">Reasons</small>
          <Textarea
            defaultValue={data.reasons}
            onChange={(e) => {
              setData({ ...data, reasons: e?.target.value });
            }}
          />
        </div>
        <Button
          loading={isLoading}
          disabled={isLoading}
          onClick={handleSubmit}
          className="!py-3"
        >
          update
        </Button>
      </div>
    </div>
  );
};

export default Mermat;
